import api from ".";

import cookiesModifier from "../utils/cookies";

import { IRepeat } from "../types/repeat";

export const getRepeats = async () => {
    try {
        const token = cookiesModifier.getCookie(process.env.REACT_APP_ADMIN_TOKEN as string);
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

        const res = await api.get(`repeats`);

        return res.data as IRepeat[];
    } catch (error) {
        throw error;
    }
}

export const createRepeat = async (data: IRepeat) => {
    const url = `repeats`;
    
    const token = cookiesModifier.getCookie(process.env.REACT_APP_ADMIN_TOKEN as string);

    const payload = { name: data.name, min: data.min, max: data.max };

    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    try {
        const res = await api.post(url, payload);
        return res.status;
    } catch (error) {
        throw error;
    }
}

export const updateRepeat = async (data: IRepeat) => {
    const url = `repeats/${data.id}`;

    const payload = { name: data.name, min: data.min, max: data.max };

    const token = cookiesModifier.getCookie(process.env.REACT_APP_ADMIN_TOKEN as string);
    
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    
    try {
        const res = await api.patch(url, payload);
        return res.status;
    } catch (error) {
        throw error;
    }
}

export const deleteRepeat = async (id: number) => {
    const url = `repeats/${id}`;
    
    const token = cookiesModifier.getCookie(process.env.REACT_APP_ADMIN_TOKEN as string);

    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    try {
        const res = await api.delete(url);
        return res.status;
    } catch (error) {
        throw error;
    }
}